export default __webpack_public_path__ + "static/media/G2PS_150.c42ca728.jpg";